<template>
  <el-row>
    <i class="material-icons" v-if="rowdata.paymentStatus=='pending'">watch_later</i>
      <i class="material-icons" style="color:green" v-else>check_circle</i>
    <el-tag :type="(rowdata.paymentStatus=='pending')?'info':'success'">
      
      <span style="text-transform:uppercase;margin-top:-4px;">{{rowdata.paymentsrc}}</span>
    </el-tag>
  </el-row>
</template>

<script>
import { fetchList } from "~/api/resource";
import { mapGetters } from "vuex";

export default {
  name: "v-payment",
  props: {
    value: {
      default: null
    },
    rowdata: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
